import { get2 } from "@/shared/axios";
import useBranches from "@/shared/hooks/useBranches";
import { Onboarding } from "@/shared/utils/interfaces";
import { useQuery } from "@tanstack/react-query";

interface OnboardingResponse {
  activated: Onboarding[];
  not_activated: Onboarding[];
}

const useOnboardingsQuery = () => {
  const branches = useBranches();
  const query = useQuery<OnboardingResponse>({
    queryKey: ["onboardings"],
    queryFn: () => get2(`/internal/secure/pos/v1/all/activation/activities`),
  });
  return query;
};

export default useOnboardingsQuery;
